import axiosClient from 'config/axios';
import tokenConfig from 'config/auth';

import {
  GET_PURCHASE_ORDERS, ADD_PURCHASE_ORDER, UPDATE_PURCHASE_ORDER_STATUS, UPDATE_PURCHASE_ORDER_PRODUCTS, UPDATE_PURCHASE_ORDER_RECEIVED, UPDATE_PURCHASE_ORDER_PAYMENT, UPDATE_PURCHASE_ORDER_PAY_DATE, SHALLOW_DELETE_PURCHASE_ORDER
} from 'redux/actionTypes';
import { incrementIDGen, incrementProductQuantities, incrementVendorPayable, decrementVendorPayable } from '.';
import { purchaseOrder } from 'variables/idGenType';
import { Approved } from 'variables/status';

export const getPurchaseOrders = () => (dispatch, getState) => {
  axiosClient
    .get('/api/purchaseOrders', tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_PURCHASE_ORDERS,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const addPurchaseOrder = (newPurchaseOrder, userId) => (dispatch, getState) => {
  axiosClient
    .post('/api/purchaseOrders', newPurchaseOrder, tokenConfig(getState))
    .then(res => {
      dispatch(incrementIDGen({ id: userId, field: purchaseOrder }));
      dispatch({
        type: ADD_PURCHASE_ORDER,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const updatePurchaseOrderStatus = (updatedStatus, updates) => (dispatch, getState) => {
  axiosClient
    .patch('/api/purchaseOrders/status', updatedStatus, tokenConfig(getState))
    .then(res => {
      if(res.data.status === Approved) dispatch(incrementVendorPayable({ id: updates.vendorId, incrementAmount: updates.incrementAmount }));
      dispatch({
        type: UPDATE_PURCHASE_ORDER_STATUS,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const updatePurchaseOrderProducts = (arrivedProducts, updatedProducts) => (dispatch, getState) => {
  axiosClient
    .patch('/api/purchaseOrders/products', arrivedProducts, tokenConfig(getState))
    .then(res => {
      dispatch(incrementProductQuantities(updatedProducts));
      dispatch({
        type: UPDATE_PURCHASE_ORDER_PRODUCTS,
        payload: { id: arrivedProducts.purchaseOrderId, updatedProducts: res.data }
      });
    })
    .catch(err => console.log(err))
};

export const updatePurchaseOrderReceived = (id) => (dispatch, getState) => {
  axiosClient
    .patch('/api/purchaseOrders/received', { id }, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: UPDATE_PURCHASE_ORDER_RECEIVED,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const updatePurchaseOrderPayment = (updatedPayment, updates) => (dispatch, getState) => {
  axiosClient
    .put('/api/purchaseOrders/payment', updatedPayment, tokenConfig(getState))
    .then(res => {
      dispatch(decrementVendorPayable({ id: updates.vendorId, decrementAmount: updates.decrementAmount }));
      dispatch({
        type: UPDATE_PURCHASE_ORDER_PAYMENT,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const updatePurchaseOrderPaymentDate = (updatedDate) => (dispatch, getState) => {
  axiosClient
    .patch('/api/purchaseOrders/pay-date', updatedDate, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: UPDATE_PURCHASE_ORDER_PAY_DATE,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const deletePurchaseOrder = (id) => (dispatch, getState) => {
  axiosClient
    .delete('/api/purchaseOrders/shallow', { params: { id }, ...tokenConfig(getState) })
    .then(res => {
      if(res.status === 204) {
        dispatch({
          type: SHALLOW_DELETE_PURCHASE_ORDER,
          payload: { id }
        });
      }
    })
    .catch(err => console.log(err))
};